import {
  type ApolloClient,
  type NormalizedCacheObject,
  gql,
} from '@apollo/client';

const QUERY_REFEREE_REPORTS = gql`
  query ($applicationNo: String!) {
    adminQueryRefereeReports(applicationNo: $applicationNo) {
      applicationNo
      refereeName
      status
      repliedDate
      file {
        id
        name
        link
      }
      formId
      refereeId
    }
  }
`;

export const useGetRefereeReportsByApplicationNo = async (
  client: ApolloClient<NormalizedCacheObject>,
  applicationNo: string,
): Promise<any> => {
  if (applicationNo?.length !== 9) {
    return null;
  }

  const { data } = await client.query({
    query: QUERY_REFEREE_REPORTS,
    variables: { applicationNo },
    fetchPolicy: 'network-only',
  });

  return data?.adminQueryRefereeReports ?? [];
};
